import {
    Airplay,
    Box,
    TrendingUp,
    Package,
    List,
    Image as ImageIcon,
    Target,
    TicketPercent,
    Star,
    Blocks,
    User,
    Users,
    BarChart3,
    UploadCloud,
    Bell,
} from "lucide-react";

export const MENU_ITEMS = [
    {
        key: "dashboard",
        label: "Dashboard",
        icon: Airplay,
        url: "/dashboard",
    },
    {
        key: "analytics",
        label: "Analytics",
        icon: BarChart3,
        url: "/analytics",
    },
    {
        key: "users",
        label: "Manage Users",
        icon: Users,
        url: "/users",
    },
    {
        key: "bulk-tools",
        label: "Bulk Import/Export",
        icon: UploadCloud,
        url: "/bulk-tools",
    },
    {
        key: "notifications",
        label: "Notifications",
        icon: Bell,
        url: "/notifications",
    },
    {
        key: "brand",
        label: "Manage Brands",
        icon: Box,
        url: "/brand",
    },
    {
        key: "category",
        label: "Manage Categories",
        icon: List,
        url: "/category", // list page
    },
    {
        key: "product",
        label: "Manage Products",
        icon: Package,
        url: "/product",
    },
    {
        key: "goal-category",
        label: "Manage Goal Categories",
        icon: Blocks,
        url: "/goal-category", // list page
    },
    {
        key: "banner",
        label: "Manage Banners",
        icon: ImageIcon,
        url: "/banner",
    },
    {
        key: "custom-goal",
        label: "Manage Custom Goal",
        icon: Target,
        url: "/custom-goal",
    },
    {
        key: "product-coupon",
        label: "Manage Product Coupons",
        icon: TicketPercent,
        url: "/product-coupon",
    },
    {
        key: "feature",
        label: "Manage FAQs",
        icon: Star,
        url: "/pages/faqs",
    },
    {
        key: "feature video",
        label: "Manage Feature Videos",
        icon: Star,
        url: "/pages/feature-video",
    },
    {
        key: "boarding",
        label: "Manage Onboarding Q&A",
        icon: Blocks,
        url: "/boarding-system", // list page
    },
    {
        key: "spend-tracker",
        label: "SpendTracker Categories",
        icon: TrendingUp,
        url: "/spend-tracker",
    },
    {
        key: "admin",
        label: "Manage Staff",
        icon: User,
        url: "/admin",
    },
];

export const HORIZONTAL_MENU_ITEM = [
    {
        key: "dashboard",
        label: "Dashboard",
        icon: "ri:airplay-line",
        url: "/dashboard",
    },
    {
        key: "admin",
        label: "Admin",
        icon: "ri:user-line",
        url: "/admin",
    },
    {
        key: "analytics",
        label: "Analytics",
        icon: "ri:bar-chart-2-line",
        url: "/analytics",
    },
    {
        key: "users",
        label: "Users",
        icon: "ri:group-line",
        url: "/users",
    },
    {
        key: "bulk-tools",
        label: "Bulk Import/Export",
        icon: "ri:upload-cloud-2-line",
        url: "/bulk-tools",
    },
    {
        key: "notifications",
        label: "Notifications",
        icon: "ri:notification-3-line",
        url: "/notifications",
    },
    {
        key: "product",
        label: "Product",
        icon: "ri:package-line",
        url: "/product",
    },
    {
        key: "brand",
        label: "Brand",
        icon: "ri:box-line",
        url: "/brand",
    },
    {
        key: "category",
        label: "Category",
        icon: "ri:list-check-2",
        url: "/category", // list page
    },
    // dynamic route, hidden from static menu
    {
        key: "category-details",
        label: "Category Details",
        icon: "ri:file-text-line",
        url: "/category/:id",
    },
    {
        key: "banner",
        label: "Banner",
        icon: "ri:image-line",
        url: "/banner",
    },
    {
        key: "custom-goal",
        label: "Custom Goal",
        icon: "ri:target-line",
        url: "/custom-goal",
    },
    {
        key: "product-coupon",
        label: "Product Coupon",
        icon: "ri:ticket-2-line",
        url: "/product-coupon",
    },
    {
        key: "goal-category",
        label: "Goal Category",
        icon: "ri:flag-line",
        url: "/goal-category",
    },
    {
        key: "feature",
        label: "Feature",
        icon: "ri:star-line",
        url: "/pages/faqs",
    },
    // {
    //     key: "faq",
    //     label: "FAQ",
    //     icon: "ri:question-line",
    //     url: "/pages/faqs",
    // },
    {
        key: "spend-tracker",
        label: "Spend Tracker",
        icon: "ri:trending-up-line",
        url: "/spend-tracker",
    },
];
